export * as Api from './api';
export var TrancheVisibility;
(function (TrancheVisibility) {
    TrancheVisibility["ShowOnTranche"] = "tranche";
    TrancheVisibility["ShowOnFirm"] = "firm";
})(TrancheVisibility || (TrancheVisibility = {}));
//# sourceMappingURL=index.js.map